import { render } from "./LandingSS24.vue?vue&type=template&id=57088244&scoped=true"
import script from "./LandingSS24.vue?vue&type=script&lang=js"
export * from "./LandingSS24.vue?vue&type=script&lang=js"

import "./LandingSS24.vue?vue&type=style&index=0&id=57088244&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57088244"]])

export default __exports__